/**
 * Users reports listing — saved user reports.
 */
import { Users, Calendar, Filter } from 'lucide-react';
import { ReportsPage } from '@/components/reports/ReportsPage';
import { ConfigBadge } from '@/components/reports/ConfigBadge';
import { PRESET_LABELS } from '@/lib/reports.types';
import { countFilters } from '@/lib/filters';

const iconCls = 'w-3 h-3 shrink-0';

function renderBadges(config: Record<string, unknown>) {
  const preset = ((config.datePreset as string) || (config.preset as string) || '');
  const startDate = ((config.startDate as string) || (config.start as string) || '');
  const endDate = ((config.endDate as string) || (config.end as string) || '');
  const filterCount = countFilters(config.filters);

  const dateLabel = preset
    ? PRESET_LABELS[preset] || preset.replace(/_/g, ' ')
    : startDate && endDate ? `${startDate} → ${endDate}` : '';

  return (
    <>
      {dateLabel && <ConfigBadge icon={<Calendar className={iconCls} />} text={dateLabel} color="amber" />}
      {filterCount > 0 && <ConfigBadge icon={<Filter className={iconCls} />} text={`${filterCount} filter${filterCount > 1 ? 's' : ''}`} color="rose" />}
    </>
  );
}

export function UsersReports() {
  return (
    <ReportsPage
      sectionId="users"
      sectionRoute="/users"
      title="Users"
      subtitle="Browse active users, profiles, sessions, and acquisition details"
      emptyIcon={Users}
      emptyDescription="Create your first users report to browse and filter active users"
      showFolders
      accentColor="sky"
      cardIcon={<Users className="w-4 h-4 text-sky-500" />}
      cardIconBgClass="bg-sky-50"
      renderBadges={renderBadges}
    />
  );
}
